export default __webpack_public_path__ + "static/media/imagePrintContentFour.8136ca18.png";